import apiClient from './apiClient';

export const getVideos = (params) => apiClient.get('/videos', { params });
export const getVideoById = (id) => apiClient.get(`/videos/${id}`);

// Broadcasts
export const getBroadcasts = (params) => apiClient.get('/broadcasts', { params });
export const getLiveBroadcasts = () => apiClient.get('/broadcasts/live');
export const getUpcomingBroadcasts = (params) => apiClient.get('/broadcasts/upcoming', { params });
export const getPastBroadcasts = (params) => apiClient.get('/broadcasts/past', { params });
export const getBroadcastById = (id) => apiClient.get(`/broadcasts/${id}`);

// Broadcast filter trees
export const getBroadcastFilterTree = () => apiClient.get('/broadcasts/filter-tree');
export const getBroadcastFilterTreeBySpeaker = (speaker) => apiClient.get(`/broadcasts/filter-tree/speaker/${encodeURIComponent(speaker)}`);
export const getBroadcastFilterTreeByLocation = (location) => apiClient.get(`/broadcasts/filter-tree/location/${encodeURIComponent(location)}`);
export const getBroadcastFilterTreeLive = () => apiClient.get('/broadcasts/filter-tree/live');

export const getVideoFilterTree = () => apiClient.get('/videos/filter-tree');
export const getVideoFilterTreeByCategory = (category) => apiClient.get(`/videos/filter-tree/category/${category}`);

export const getSettings = (params) => apiClient.get('/settings', { params });

export const getPosters = (params) => apiClient.get('/posters', { params });
export const getPosterById = (id) => apiClient.get(`/posters/${id}`);
export const getPostersByPrayerCenter = (prayerCenterId) =>
  apiClient.get('/posters', { params: { prayer_center_id: prayerCenterId, tab: 'upcoming', limit: 10, page: 1 } });
export const getRepresentations = (params) => apiClient.get('/representations', { params });
export const getRepresentationById = (id) => apiClient.get(`/representations/${id}`);

export const getChannels = (params) => apiClient.get('/channels', { params });

export const getCategories = (params) => apiClient.get('/categories', { params });

export const getPages = (params) => apiClient.get('/pages', { params });
export const getPageBySlug = (slug) => apiClient.get(`/pages/${slug}`);

export const getHomeFeed = () => apiClient.get('/home');

export const postContactMessage = (data) => apiClient.post('/contacts', data);

export const getPrivacyPolicy = () => apiClient.get('/privacy-policy');
export const getTermsConditions = () => apiClient.get('/terms-conditions');
